
import { useEffect } from 'react';
import { Grid, TextField, MenuItem, Autocomplete } from '@mui/material';
import { usePlanillassStore, useUsuariosStore } from '../../../../store';
import { InputSeparadorDecimal } from '../../inputs/InputSeparadorDecimal';






export const FormInfoCargueros = ({ onCahnge }) => {


    const { formValues } = usePlanillassStore();
    const { startListTodosOperarios, operarios } = useUsuariosStore();

    
    
    useEffect(() => {
        // startListTodosClinetes('CLIENTE');
        startListTodosOperarios('GALPONERO');
    }, []);



    return (

        <>
        <Grid item xs={12}>
            <Autocomplete multiple size="small"
                options={operarios || []}
                getOptionLabel={ (option) => option.nombre }
                value={operarios?.filter((op) => formValues.cargueros?.includes(op.id)) || []}
                onChange={(_, newValue) => {
                    const newIds = newValue.map((item) => item.id);
                    onCahnge({ target: { name: 'cargueros', value: newIds }, });
                }}
                renderInput={(params) => (
                    <TextField {...params} fullWidth
                        label="Seleccione Cargueros" placeholder="Cargueros"
                    />
                )}
            />
        </Grid>

        <Grid item xs={12} sm={6}>
            <TextField required
                size="small"
                select
                label="Tipo Acuerdo"
                fullWidth
                name='acuerdo'
                value={formValues.acuerdo}
                onChange={ onCahnge }
            >
                <MenuItem value='UNIDAD' >UNIDAD</MenuItem>
                <MenuItem value='PRECIO' >PRECIO</MenuItem>
            </TextField>
        </Grid> 

        <Grid item xs={12} sm={6}>
            <InputSeparadorDecimal required
                size="small"
                label='Valor Acordado'
                placeholder='Valor Acordado'
                fullWidth
                name='valorAcordado'
                value={formValues.valorAcordado}
                onChange={ onCahnge }
            />
        </Grid>
        </>
    )
}

